import { render, staticRenderFns } from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=template&id=2bdab792&scoped=true"
import script from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js"
export * from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdab792",
  null
  
)

export default component.exports